module.exports = __webpack_public_path__ + "static/img/15.21cdee1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/15.jpg
// module id = bHAC
// module chunks = 0